export const formatCurrencyToApi = (value: any) => {
  if(value === "" || undefined || null) throw new Error(); 
  if(!value?.startsWith("R")) return parseFloat(value?.replaceAll(".", "").replaceAll(",", "."));
  let valueWithoutRs = value?.split('$');
  return parseFloat(valueWithoutRs[1].replaceAll(".", "").replaceAll(",", "."));
};

export const formatFromApiToInput = (value: any) => {
  if(value === "" || undefined || null) return ""; 
  return String(value)?.replace(".", ",");
};

export const formatCurrencyToApiNoThrow = (value: any) => {
  if(value === "" || undefined || null) return 0; 
  if(!value?.startsWith("R")) return parseFloat(value?.replaceAll(".", "").replaceAll(",", "."));
  let valueWithoutRs = value?.split('$');
  return parseFloat(valueWithoutRs[1].replaceAll(".", "").replaceAll(",", "."));
};